import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import {  FilePicker, Button, IconReload, Card, TextBox} from "@veneer/core";
import ConnectAPI from "../../services/api";
import { downloadFile } from "../../services/FileDownloader/FileDownloader";

const connectApi = new ConnectAPI();
function Conci(props) {
    const [FileQad,setFileQad]=useState(null);
    const [Filedaily,setFiledaily]=useState(null);
    const [Filemonthly,setFilemonthly]=useState(null);
    const [Filedelta,setFiledelta]=useState(null);
    const [FilePrintOS,setFilePrintOS]=useState(null);
    const [loadingbtn, setloadingbtn]=useState(false);


    const [Fileinstallbase, setFileinstallbase]=useState(null);
    const [FileQADConnection, setFileQADConnection ]=useState(null);
    const [FilePrintOsReport, setFilePrintOsReport]=useState(null);
    const [loadingbtn2, setloadingbtn2]=useState(false);
    useEffect(() => {
        connectApi.get("api/Channels/getfileconci","", setconfig).catch((error) => {
            console.log(error);
            Swal.fire(
              "Error " + error?.response?.status,
              error?.response?.data,
              "error"
            );
          });
    }, []);
    
    const setconfig=(status,data)=>{
        setFileQad(data.qaD_Connection);
        setFiledelta(data.delta_Impression);
        setFilePrintOS(data.print_OS_Report)
    }
    const submit=()=>{
        setloadingbtn(true);
        let data = new FormData();
        /*data.append("FileQad", File);
        data.append("FileQad",FileQad);*/

        /*data.append("FilePrintOS", File);
        data.append("FilePrintOS",FilePrintOS);*/

        data.append("Filedaily", File);
        data.append("Filedaily",Filedaily);

        data.append("Filemonthly", File);
        data.append("Filemonthly",Filemonthly);

        /*data.append("Filedelta", File);
        data.append("Filedelta",Filedelta);*/

        connectApi.postmultifile(
            "api/Channels/ulploadconci",
            data,
            handleReloadData
        ).catch((error) => {
            setloadingbtn(false);
            Swal.fire(
                "Error " ,
                error?.response?.data,
                "error"
            );
        });
    }
    const submit2=()=>{
        if (Fileinstallbase != null && FileQADConnection!= null && FilePrintOsReport!=null){
            setloadingbtn2(true);
            let data = new FormData();
            data.append("Fileinstallbase", File);
            data.append("Fileinstallbase",Fileinstallbase);

            data.append("FileQADConnection", File);
            data.append("FileQADConnection",FileQADConnection);

            data.append("FilePrintOsReport", File);
            data.append("FilePrintOsReport",FilePrintOsReport);

            connectApi.postmultifile(
                "api/Channels/ulploadinstallbase",
                data,
                handleReloadData2
            ).catch((error) => {
                setloadingbtn2(false);
                Swal.fire(
                    "Error " ,
                    error?.response?.data,
                    "error"
                );
            });
        }
        
    }
    const handleReloadData = (status,data) => {
        downloadFile("conciliaton.xlsx");
        setloadingbtn(false);
        window.location.reload();
    }
    const handleReloadData2 = (status,data) => {
        downloadFile("HPInstallbase.xlsx");
        setloadingbtn2(false);
        window.location.reload();
    }
    const conci=()=>{
        return(<>
            <Row>
                <Col>
                    <h3>Preconcilitation</h3>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%' , marginBottom:'15px' }}>
                        <TextBox
                            value={"QAD upload date: "+FileQad}
                            readOnly
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%' , marginBottom:'15px' }}>
                        <TextBox
                            value={"Print OS upload date: "+FilePrintOS}
                            readOnly
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%', marginBottom:'15px'  }}>
                        <FilePicker
                            id="Daily_counters"
                            separateLabel
                            label="Daily Counters"
                            accept=".xlsx,.xls"
                            onChange={(event)=>{
                                setFiledaily(event.target.files[0])
                            }}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%', marginBottom:'15px'  }}>
                        <FilePicker
                            id="Tpi_monthly"
                            separateLabel
                            label="Tpi Monthly"
                            accept=".xlsx,.xls"
                            onChange={(event)=>{
                                setFilemonthly(event.target.files[0])
                            }}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%', marginBottom:'15px' }}>
                        <TextBox
                            value={"Delta file upload date: "+Filedelta}
                            readOnly
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button 
                    leadingIcon={<IconReload />}
                    loading={loadingbtn}
                    onClick={submit}
                    >
                        Generate and download
                    </Button>
                </Col>
            </Row>
        </>);
    }
    const installbase=()=>{
        return <>
            <Row>
                <Col>
                    <h3>Installbase Report</h3>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%', marginBottom:'15px' }}>
                        <FilePicker
                            id="Install_Base_Report"
                            separateLabel
                            label="Install Base Report"
                            accept=".xlsx,.xls"
                            onChange={(event)=>{
                                setFileinstallbase(event.target.files[0])
                            }}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%', marginBottom:'15px' }}>
                        <FilePicker
                            id="QAD_Connection"
                            separateLabel
                            label="QAD Connection"
                            accept=".csv"
                            onChange={(event)=>{
                                setFileQADConnection(event.target.files[0])
                            }}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ maxWidth: 400, width: '100%', marginBottom:'15px' }}>
                        <FilePicker
                            id="Print_OS_Report"
                            separateLabel
                            label="Print OS Report"
                            accept=".xlsx,.xls"
                            onChange={(event)=>{
                                setFilePrintOsReport(event.target.files[0])
                            }}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button 
                    leadingIcon={<IconReload />}
                    loading={loadingbtn2}
                    onClick={submit2}
                    >
                        Generate and download
                    </Button>
                </Col>
            </Row>
        </>
    }
    return <>
        <Row>
            <Col>
                <Card content={conci()} appearance="outlined" style={{padding: '2%'}} />
            </Col>
            <Col>
                <Card content={installbase()} appearance="outlined" style={{padding: '2%'}} />
            </Col>
        </Row>
        
    </>
    
}
export default Conci;
